import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FeahterIconModule } from 'src/app/core/feather-icon/feather-icon.module';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { OwlDateTimeModule, OwlNativeDateTimeModule, OWL_DATE_TIME_FORMATS } from 'ng-pick-datetime';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DirectivesModule } from 'src/app/views/layout/directives/directives.module';
import { VehicleService } from 'src/app/services/vehicle.service';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ReportsService } from 'src/app/services/reports.service';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { RegionService } from 'src/app/services/region.service';
import { DivisionService } from 'src/app/services/division.service';
import { SubDivisionService } from 'src/app/services/subdivision.service';
import { MatSelectModule } from '@angular/material/select';
import { MatSelectFilterModule } from 'mat-select-filter';
import { TripEntryService } from 'src/app/services/tripentry.service';
import { MtsDateFormate } from 'src/app/constant/mtsdateformate';
import { MachineryWiseReportComponent } from './machinery-wise-report.component';

const routes: Routes = [
  {
      path: '',
      component: MachineryWiseReportComponent
  },
]

@NgModule({
  declarations: [MachineryWiseReportComponent],
  providers: [
    ReportsService,
    VehicleService,
    RegionService,
    DivisionService,
    SubDivisionService,
    TripEntryService,
    { provide: MAT_DIALOG_DATA, useValue: {} },
    { provide: MatDialogRef, useValue: {} },
    { provide: OWL_DATE_TIME_FORMATS, useValue: MtsDateFormate }, 
    
],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    FormsModule,
    FeahterIconModule,
    NgbDropdownModule,
    FormsModule,
    TranslateModule,
    ReactiveFormsModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    MatIconModule,
    MatTooltipModule,
    MatButtonModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatInputModule,
    MatFormFieldModule,
    MatDialogModule,
    DirectivesModule,
    NgMultiSelectDropDownModule.forRoot(),
    PdfViewerModule,
    MatSelectModule, 
    MatSelectFilterModule
  ]
})
export class MachineryWiseReportModule { }
